import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, MapPinOff } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center py-12 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <MapPinOff className="h-7 w-7" />
      </div>

      <p className="mt-6 text-sm font-bold uppercase tracking-wide text-muted-foreground">
        Error 404
      </p>
      <h1 className="mt-2 text-2xl font-bold text-foreground sm:text-3xl">
        This page took a wrong turn
      </h1>
      <p className="mt-3 max-w-md text-sm text-muted-foreground">
        The link may be old or mistyped. Nothing here to see, but your orders are
        one tap away.
      </p>

      {location.pathname && location.pathname !== "/" && (
        <p className="mt-4 rounded-md bg-muted px-3 py-1.5 font-mono text-xs text-muted-foreground">
          {location.pathname}
        </p>
      )}

      <Button onClick={() => navigate("/")} className="mt-8 h-11 px-6">
        <ArrowLeft className="h-4 w-4" />
        Back to orders
      </Button>
    </div>
  );
};

export default NotFound;
